import React, { useEffect, useState } from 'react';
import { ContentContext } from '../context/ContentContext';
import { getSiteCoreContent } from '../services/sitecoreServices';

export const ContentProvider = ({ children }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    getContent(controller.signal);

    return () => {
      controller.abort();
    };
  }, []);

  const getContent = (signal) => {
    getSiteCoreContent(signal)
      .then((result) => {
        if (signal.aborted) return;
        if (result.status !== 200) {
          setData(false);
        }
        setData(result.data);
      })
      .catch((error) => {
        if (signal.aborted) return;
        if (error.request) {
          setData(false);
        }
      });
  };

  return <ContentContext.Provider value={data}>{children}</ContentContext.Provider>;
};
